import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Users } from '../pages/layout/list-users/list-users.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { AngularFireAuth } from '@angular/fire/auth';
import axios, { AxiosError, AxiosResponse } from 'axios'
import { API_ENDPOINTS } from './api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  orgUrl = "";
  baseUrl = 'https://prod.baas.batterypool.com/driver/api'

  constructor(
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
    ) {}

  getUsers() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Users>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.RidersCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Users;
        const id = action.payload.doc.id;
        // return data;
        return { id, ...data };
      });
    });
  }

  getUserData(uid) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.RidersCollection).doc(uid).snapshotChanges().pipe(map(action => {
      const data = action.payload.data();
      const id = action.payload.id;
      //@ts-ignore
      return { id, ...data };
    }));
  }

  getLoginUserData(uid) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.CustomersCollection).doc(uid).snapshotChanges().pipe(
      map(action => {
        const data = action.payload.data();
        const id = action.payload.id;
        //@ts-ignore
        return { id, ...data };
      })
    );
  }

  addUser(data) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) => {
      return this.afAuth.auth.createUserWithEmailAndPassword(data.Email,'root123').then(
        value => {
          let loginData = {
            UserType: 'Rider',
            Email: data.Email,
          };
          this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.LoginUsersCollection).doc(value.user.uid).set(loginData);
          this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.RidersCollection).doc(value.user.uid).set({...data, id:value.user.uid});
          this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.RidersPaymentDashboardCollection).doc(value.user.uid).set({id:value.user.uid, data:{}});
          this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.MobileNotificationsCollection).doc(value.user.uid).set({"NotificationsList":[]});
          console.log(value.user.uid);
          resolve(value.user.uid);
        }
      ).catch(err => {
        window.alert(err.message);
      });
    }).catch(error => {
      window.alert(error.message);
    });
  }

  editUser(data,id) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.RidersCollection).doc(id).update(data).then(
        res => {
          this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.RidersPaymentDashboardCollection).doc(id).update(data).then(
            res => {
              resolve(id);
            }, err => reject(err)
          );
        }, err => reject(err)
      );
    });
  }

  async deleteUser(uid) {
    try{
    const res = await axios.delete(`${API_ENDPOINTS.driver.deleteDriver}/${uid}`);
    console.log(res)
    return true;
    }catch(error){
     console.log("user not deleted")
     return false;
    }
  }

  async addDriverUser(userData) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        maxBodyLength: Infinity,
        url: `${API_ENDPOINTS.driver.addDriver}`,
        headers: { 
          'Content-Type': 'application/json',
        },
        data : userData
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async editDriverUser(userData, uid) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'put',
        // maxBodyLength: Infinity,
        url: `${API_ENDPOINTS.driver.editDriver}/${uid}`, 
        headers: { 
          'Content-Type': 'application/json',
        },
        data : userData
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async assignBatteries(data, uid) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'patch',
        url: `${API_ENDPOINTS.driver.assignBatteries}/${uid}`,
        headers: { 
          'Content-Type': 'application/json',
        },
        data : data
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
}

async assignCharger(data, driverId) {
  return new Promise((resolve, reject) => {
    axios.request({
      method: 'post',
      url: `${API_ENDPOINTS.charger.assignCharger}/${driverId}`,
      headers: { 
        'Content-Type': 'application/json',
      },
      data : data
    })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
}

async getAllDriverData() {
  return new Promise((resolve, reject) => {
    axios.request({
      method: 'get',
      url: `${API_ENDPOINTS.driver.getAllDriverData}`,
    })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
}

async getListOfDriverNames() {
  return await new Promise((resolve, reject) => {
    axios.request({
      method: 'get',
      url: `${API_ENDPOINTS.driver.getListOfDriverNames}`,
    })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
}

async getAllDrivers(offset=0,limit=100000) {
  return await new Promise((resolve, reject) => {
    axios.request({
      method: 'get',
      url: `${API_ENDPOINTS.driver.getAllDrivers}?limit=${limit}&offset=`+`${offset}`,
    })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
}

async getListOfDriverIds() {
  return await new Promise((resolve, reject) => {
    axios.request({
      method: 'get',
      url: `${API_ENDPOINTS.driver.getListOfDriverIds}`,
    })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
}


async getDriverDetails(driverUid) {
  return await new Promise((resolve, reject) => {
    axios.request({
      method: 'get',
      url: `${API_ENDPOINTS.driver.getDriverDetails}/${driverUid}`,
    })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
}



  async getDriverDetailsByDriverId(search) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'get',
        url: `${API_ENDPOINTS.driver.getDriverDetailsByDriverId}/${search}`,
      })
      .then((response: AxiosResponse) => {
        resolve(response);  // Resolve the response data
      })
      .catch((error: AxiosError) => {
        reject(error);  // Reject with error in case of failure
      });
    });
  }

  async getAllBatteries() {
    axios.request({
      method: 'get',
      url: `${API_ENDPOINTS.driver.getBatteries}`,
    })
    .then((response) => {
      console.log(JSON.stringify(response.data));
      return response.data.data
    })
    .catch((error) => {
      console.error(error.response);
      return error
    });
  }

  async getAllBatteriesAvailable() {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'get',
        url: `${API_ENDPOINTS.battery.getAllBatteriesAvailable}`,
      })
      .then((response: AxiosResponse) => {
        resolve(response);  // Resolve the response data
      })
      .catch((error: AxiosError) => {
        reject(error);  // Reject with error in case of failure
      });
    });
  }

  async getDriverOrgs() {
    return await new Promise((resolve, reject) => {
      axios.request({
        method: 'get',
        url: `${API_ENDPOINTS.general.getDriverOrgs}`,
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async getDriverDeatilsByDriverName(search){
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'get',
        url: `${API_ENDPOINTS.driver.getDriverDeatilsByDriverName}/${search}`,
      })
      .then((response: AxiosResponse) => {
        resolve(response);  // Resolve the response data
      })
      .catch((error: AxiosError) => {
        reject(error);  // Reject with error in case of failure
      });
    });
  }

  async getCities() {
    return await new Promise((resolve, reject) => {
      axios.request({
        method: 'get',
        url: `${API_ENDPOINTS.general.getCities}`,
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async assignSubscriptionPlanToDriver(payload) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        url: `${API_ENDPOINTS.driver.assignSubcriptionToDriver}`, 
        headers: { 
          'Content-Type': 'application/json',
        },
        data : payload
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

}
